<h2>Provider Notified</h2>

<assessment-row title="Provider Notified?">
    <p>{{ data.isNotified | booleanToYesNo }} </p>
    <!-- <p>{{ data.isNotified }} </p> -->
</assessment-row>
<assessment-row title="Who">
    <p>{{ data.notifiedPerson }}</p>
</assessment-row>
<assessment-row title="What">
    <p>{{ data.notifiedWhat }}</p>
</assessment-row>